import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-brand-gold bg-brand-ivory" data-id="element-87" data-mp="4lyuukqi8cd4">
      <p className="flex items-center justify-center gap-1.5 bg-brand-petrol px-3 py-1.5 font-sub text-xs font-semibold uppercase tracking-widest text-brand-mint" data-id="element-88" data-mp="4jm5vnmbx1qk">
        <GraduationCapIcon size={13} aria-hidden="true" data-id="element-89" data-mp="xbpch3rchwdz" />
        Método de aprendizaje paso a paso
      </p>

      <div className="mx-auto max-w-2xl px-3 pb-5 pt-3 text-center sm:px-5" data-id="element-90" data-mp="s9q75oc1opee">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[2.6rem] leading-[0.95] text-brand-petrol sm:text-6xl" data-id="element-91" data-mp="nb6k1klpt7kg">
          El sistema completo para{' '}
          <span className="text-brand-emerald underline decoration-brand-mint decoration-[6px] underline-offset-[3px]" data-id="element-92" data-mp="3j9kalakrlffl">
            comprender farmacología
          </span>{' '}
          y organizar tu estudio desde cero
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-muted sm:text-base" data-id="element-93" data-mp="39cfjqxfz4vsg">
          Aprendé los fundamentos, relacioná los grupos de medicamentos y
          practicá con ejercicios explicados,{' '}
          <strong className="font-semibold text-brand-petrol" data-id="element-94" data-mp="2qhqurk8mavyx">
            sin perderte entre apuntes, capturas y resúmenes sueltos.
          </strong>
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.1
      }} className="mt-2.5 inline-block rounded-lg bg-brand-petrol px-3 py-1.5 font-sub text-xs font-bold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-95" data-mp="2hkggdq0i6qps">
          {PRODUCT_NAME} · <span className="text-brand-gold" data-id="element-96" data-mp="ibow6f6accrq">6 Tomos + 5 Bonos</span>
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.14
      }} className="mt-2.5 block overflow-hidden rounded-2xl border-4 border-brand-emerald bg-white" data-id="element-97" data-mp="ddf44dfuxsac">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-98" data-mp="111y8wizp7mxo" />
        </motion.a>

        <p className="mt-1.5 font-sub text-xs font-semibold text-brand-muted sm:text-sm" data-id="element-99" data-mp="3ltgo5tkf8wpx">
          6 tomos digitales y 5 bonos para comprender, relacionar y repasar.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.18
      }} className="mt-2.5" data-id="element-100" data-mp="1x9b6f48dr7e5">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-101" data-mp="26a98vi3676um">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>
          <p className="mt-2.5 text-xs font-semibold text-brand-muted" data-id="element-102" data-mp="2b0ze8vblj9pb">
            Material 100% digital • Estudiá a tu ritmo
          </p>
        </motion.div>
      </div>
    </header>;
}